import type { MoneyTokens } from './types';

export const money: MoneyTokens = {
  colors: {
    default: 'neutral.100',
  },
  fontWeights: {
    default: 'bold',
    strikeThrough: 'medium',
    tiny: 'bold',
  },
  fontSizes: {
    defaultPart: {
      tiny: 'unset',
      small: 'heading.0',
      medium: 'heading.1',
    },
    nonIntegerPart: {
      tiny: 'unset',
      small: 'body.3',
      medium: 'body.2',
    },
  },
};
